import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import Dialog from "@material-ui/core/Dialog";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import MuiDialogContent from "@material-ui/core/DialogContent";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import Typography from "@material-ui/core/Typography";
import axios from "axios";
import FileUploader from "../FileUploader/FileUploader";
import { Box, Checkbox, CircularProgress, TextField } from "@material-ui/core";

import { logicOfPolicyChoice } from "./logicOfPolicyChoice";
import stylePaymentBack from "./PaymentBack.module.css";
import moment from "moment";
import { formatMoney } from "../../lib/helperFuncs";
import Button from "@material-ui/core/Button";

const styles = (theme) => ({
    root: {
        margin: 0,
        padding: theme.spacing(2),
    },
    closeButton: {
        position: "absolute",
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[500],
    },
});

const Radio = (props) => {
    const handleChange = (e) => {
        props.setSelectedOption(e.target.value);
        if (props.onChange) {
            props.onChange(e);
        }
        if (props.handleChange) {
            props.handleChange(e);
        }
    };

    return (
        <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
            {props.options.map((option) => (
                <label
                    key={option.val}
                    style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                    }}
                >
                    <input
                        type="radio"
                        name="radio"
                        value={option.val}
                        checked={props.selectedOption == option.val}
                        onChange={handleChange}
                        disabled={props.disabled}
                        data-name={option.label}
                    />
                    {option.label}
                </label>
            ))}
        </div>
    );
};

const DialogTitle = withStyles(styles)((props) => {
    const { children, classes, onClose } = props;
    return (
        <MuiDialogTitle disableTypography>
            <Typography variant="h5">{children}</Typography>
            {onClose ? (
                <IconButton
                    aria-label="close"
                    className={classes.closeButton}
                    onClick={onClose}
                >
                    <CloseIcon />
                </IconButton>
            ) : null}
        </MuiDialogTitle>
    );
});

const DialogContent = withStyles((theme) => ({
    root: {
        padding: theme.spacing(2),
    },
}))(MuiDialogContent);

const PopupData = (props) => {
    const { loading } = props;
    const { radioOptions } = props;
    const { reservationId } = props;
    const { guestId } = props;
    const { sumTotal } = props;
    const { paidAmount } = props;
    const { refundedAmount } = props;
    const { hotelId } = props;
    const { paymentNumber } = props;
    const { orderNumber } = props;
    const { paymentMade } = props;
    return (
        <Dialog
            onClose={() => props.setOpenPaymentBackDialog(false)}
            aria-labelledby="customized-dialog-title"
            open={props.openPaymentBackDialog}
            PaperProps={{
                style: {
                    minWidth: "400px",
                },
            }}
        >
            <DialogTitle
                id="customized-dialog-title"
                onClose={() => props.setOpenPaymentBackDialog(false)}
            >
                Возврат Денежных средств
            </DialogTitle>
            <DialogContent>
                {loading === true ? (
                    <Box
                        display="flex"
                        justifyContent="center"
                        alignItems="center"
                        height="100%"
                        minHeight="200px"
                    >
                        <CircularProgress />
                    </Box>
                ) : paymentMade === false ? (
                    <Box
                        display="flex"
                        justifyContent="center"
                        alignItems="center"
                        height="100%"
                        minHeight="200px"
                    >
                        <Typography variant="subtitle1">
                            Оплат по данному бронированию не производилось
                        </Typography>
                    </Box>
                ) : (
                    <FormComponent
                        radioOptions={radioOptions}
                        reservationId={reservationId}
                        guestId={guestId}
                        sumTotal={sumTotal}
                        paidAmount={paidAmount}
                        refundedAmount={refundedAmount}
                        hotelId={hotelId}
                        paymentNumber={paymentNumber}
                        orderNumber={orderNumber}
                        setOpenPaymentBackDialog={
                            props.setOpenPaymentBackDialog
                        }
                        setActiveHasRefunds={props.setActiveHasRefunds}
                        setHasRefunds={props.setHasRefunds}
                    />
                )}
            </DialogContent>
        </Dialog>
    );
};

const FormComponent = (props) => {
    const [formData, setFormData] = useState({
        reservation_id: "",
        guest_id: "",
        status: "",
        amount: "",
        name: "",
        hotel_id: "",
        order_number: "",
        return_all: false,
        custom_amount: false,
    });

    const [submitting, setSubmitting] = useState(false);
    const [errors, setErrors] = useState({});
    const [previousSumBack, setPreviousSumBack] = useState(0);
    const [selectedOption, setSelectedOption] = useState("");
    const [sumBack, setSumBack] = useState(0);
    const [nameRefund, setNameRefund] = useState("");
    const [namePreviousRefund, setNamePreviousRefund] = useState("");
    const [uploadedFiles, setUploadedFiles] = useState([]);
    const [customAmount, setCustomAmount] = useState("");
    const [showConfirmCheckbox, setShowConfirmCheckbox] = useState(false);
    const [confirmWithoutDocs, setConfirmWithoutDocs] = useState(false);

    const [optionValues, setOptionValues] = useState({
        radio: { sum: 0, name: "" },
        return_all: { sum: props.paidAmount, name: "Вернуть все" },
        custom_amount: { sum: 0, name: "Указанная сумма" },
    });

    const availableAmount = props.paidAmount - props.refundedAmount;

    const handleChange = (e) => {
        const { name, checked } = e.target;

        if (name === "return_all") {
            setFormData((prev) => ({
                ...prev,
                return_all: checked,
                custom_amount: checked ? false : prev.custom_amount,
            }));

            if (checked) {
                // Сохраняем текущие значения перед переключением
                if (formData.custom_amount) {
                    setOptionValues((prev) => ({
                        ...prev,
                        custom_amount: {
                            sum: Number(customAmount) || 0,
                            name: "Указанная сумма",
                        },
                    }));
                } else if (selectedOption) {
                    const selectedOpt = props.radioOptions.find(
                        (opt) => opt.val === selectedOption,
                    );
                    setOptionValues((prev) => ({
                        ...prev,
                        radio: {
                            sum: selectedOpt?.sumBack || 0,
                            name: selectedOpt?.label || "",
                        },
                    }));
                }

                setSumBack(availableAmount);
                setNameRefund("Вернуть все");
            } else {
                // Восстанавливаем предыдущие значения
                if (formData.custom_amount) {
                    setSumBack(optionValues.custom_amount.sum);
                    setNameRefund(optionValues.custom_amount.name);
                } else if (selectedOption) {
                    setSumBack(optionValues.radio.sum);
                    setNameRefund(optionValues.radio.name);
                } else {
                    setSumBack(0);
                    setNameRefund("");
                }
            }
        } else if (name === "custom_amount") {
            setFormData((prev) => ({
                ...prev,
                custom_amount: checked,
                return_all: checked ? false : prev.return_all,
            }));

            if (checked) {
                // Сохраняем текущие значения перед переключением
                if (formData.return_all) {
                    setOptionValues((prev) => ({
                        ...prev,
                        return_all: {
                            sum: availableAmount,
                            name: "Вернуть все",
                        },
                    }));
                } else if (selectedOption) {
                    const selectedOpt = props.radioOptions.find(
                        (opt) => opt.val === selectedOption,
                    );
                    setOptionValues((prev) => ({
                        ...prev,
                        radio: {
                            sum: selectedOpt?.sumBack || 0,
                            name: selectedOpt?.label || "",
                        },
                    }));
                }

                const amountValue = Number(customAmount) || 0;
                setSumBack(amountValue);
                setNameRefund("Указанная сумма");
            } else {
                // Восстанавливаем предыдущие значения
                if (formData.return_all) {
                    setSumBack(optionValues.return_all.sum);
                    setNameRefund(optionValues.return_all.name);
                } else if (selectedOption) {
                    setSumBack(optionValues.radio.sum);
                    setNameRefund(optionValues.radio.name);
                } else {
                    setSumBack(0);
                    setNameRefund("");
                }
            }
        } else if (name === "radio") {
            const selectedOpt = props.radioOptions.find(
                (opt) => opt.val === e.target.value,
            );
            setNameRefund(selectedOpt?.label || "");
            setOptionValues((prev) => ({
                ...prev,
                radio: {
                    sum: selectedOpt?.sumBack || 0,
                    name: selectedOpt?.label || "",
                },
            }));
        }

        if (errors.condition) {
            setErrors((prev) => ({ ...prev, condition: undefined }));
        }
        if (errors.customAmount) {
            setErrors((prev) => ({ ...prev, customAmount: undefined }));
        }
    };

    const handleCustomAmountChange = (e) => {
        const value = e.target.value;
        if (/^\d*$/.test(value)) {
            setCustomAmount(value);
            if (formData.custom_amount) {
                setSumBack(Number(value) || 0);
            }
        }
    };

    const isAmountExceeded = () => {
        if (formData.return_all) {
            return false;
        }

        if (formData.custom_amount) {
            return Number(customAmount) > availableAmount;
        }

        if (selectedOption) {
            const selectedOpt = props.radioOptions.find(
                (opt) => opt.val === selectedOption,
            );
            return selectedOpt?.sumBack > availableAmount;
        }

        return false;
    };

    const handleFilesChange = (files) => {
        setUploadedFiles(files);

        if (errors.files) {
            const newErrors = { ...errors };
            delete newErrors.files;
            setErrors(newErrors);
        }
    };

    const validateForm = () => {
        const newErrors = {};

        if (
            !formData.return_all &&
            !selectedOption &&
            !formData.custom_amount
        ) {
            newErrors.condition = "Выберите условие возарата или введите сумму";
        }

        if (isAmountExceeded()) {
            if (formData.custom_amount) {
                newErrors.customAmount = "Сумма не может превышать оплаченную";
            } else if (selectedOption) {
                newErrors.radio =
                    "Сумма по выбранному условию превышает доступную для возврата";
            }
        }

        if (uploadedFiles.length === 0 && !confirmWithoutDocs) {
            newErrors.confirmWithoutDocs =
                "Необходимо подтвердить отправку без документов";
        }

        if (
            showConfirmCheckbox &&
            uploadedFiles.length === 0 &&
            !confirmWithoutDocs
        ) {
            newErrors.confirmWithoutDocs =
                "Необходимо подтвердить отправку без документов";
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        if (uploadedFiles.length === 0) {
            setShowConfirmCheckbox(true);
        }

        if (validateForm()) {
            const newformData = new FormData();
            newformData.append("reservation_id", props.reservationId);
            newformData.append("guest_id", props.guestId);
            newformData.append("status", "pending");
            newformData.append("amount", sumBack);
            newformData.append("name", nameRefund);
            newformData.append("hotel_id", props.hotelId);
            newformData.append("payment_number", props.paymentNumber);
            newformData.append("order_number", props.orderNumber);
            newformData.append(
                "confirmed_without_docs",
                confirmWithoutDocs ? "1" : "0",
            );
            newformData.append(
                "is_partial_refund",
                formData.custom_amount ? "1" : 0,
            );
            uploadedFiles.forEach((file) => {
                newformData.append("files[]", file);
            });

            axios
                .post("/manager/data/create_refund", newformData, {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                })
                .then((res) => {
                    props.setOpenPaymentBackDialog(false);
                    alert("Возврат оформлен");
                    setUploadedFiles([]);
                    setConfirmWithoutDocs(false);
                    setShowConfirmCheckbox(false);
                    setFormData({
                        reservation_id: "",
                        guest_id: "",
                        status: "",
                        amount: "",
                        name: "",
                        hotel_id: "",
                        order_number: "",
                    });

                    props.setActiveHasRefunds(true);
                    props.setHasRefunds(true);
                })
                .catch((error) => {
                    alert("Ошибка оформления возврата");
                    console.error(error);
                });

            setSumBack(0);
            setPreviousSumBack(0);
        }
    };

    const calcSumBack = (event) => {
        const selectedValue = event.target.value;
        const selectedOption = props.radioOptions.find(
            (opt) => opt.val === selectedValue,
        );
        setSelectedOption(selectedValue);

        if (selectedOption?.sumBack) {
            const availableAmount = props.paidAmount - props.refundedAmount;
            setPreviousSumBack(sumBack);
            setSumBack(selectedOption.sumBack);
            setNameRefund(selectedOption.label);

            if (selectedOption.sumBack > availableAmount) {
                setErrors((prev) => ({
                    ...prev,
                    radio: "Сумма по выбранному условию превышает доступную для возврата",
                }));
            } else {
                setErrors((prev) => {
                    const newErrors = { ...prev };
                    delete newErrors.radio;
                    return newErrors;
                });
            }
        }
    };

    return (
        <form onSubmit={handleSubmit} className="form-container">
            <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                mb={2}
                p={1}
                bgcolor="#f5f5f5"
                borderRadius={4}
            >
                <Typography variant="subtitle1">
                    Сумма возврата не может превышать:
                </Typography>
                <Typography variant="subtitle1" style={{ fontWeight: "bold" }}>
                    {formatMoney(availableAmount)}
                </Typography>
            </Box>
            <div className={stylePaymentBack.form_group}>
                {props?.radioOptions?.length > 0 ? (
                    <>
                        <label htmlFor="name">Условия</label>
                        <Radio
                            options={props.radioOptions}
                            onChange={calcSumBack}
                            selectedOption={selectedOption}
                            setSelectedOption={setSelectedOption}
                            disabled={
                                formData.return_all || formData.custom_amount
                            }
                            handleChange={handleChange}
                        />
                        {errors.radio && (
                            <Typography color="error">
                                {errors.radio}
                            </Typography>
                        )}
                    </>
                ) : (
                    <div>Нет подходящих условий для возврата</div>
                )}
            </div>
            <div className={stylePaymentBack.form_group}>
                <Box display="flex" alignItems="center" component="label">
                    <Checkbox
                        name="return_all"
                        color="primary"
                        checked={formData.return_all}
                        onChange={handleChange}
                    />
                    <Typography>Вернуть все</Typography>
                </Box>
                <Box display="flex" alignItems="center" component="label">
                    <Checkbox
                        name="custom_amount"
                        color="primary"
                        checked={formData.custom_amount}
                        onChange={handleChange}
                    />
                    <Typography>Указать сумму</Typography>
                </Box>

                {formData.custom_amount && (
                    <TextField
                        label="Сумма возврата"
                        variant="outlined"
                        value={customAmount}
                        onChange={handleCustomAmountChange}
                        fullWidth
                        margin="normal"
                        error={isAmountExceeded() || !!errors.customAmount}
                        helperText={
                            isAmountExceeded()
                                ? "Сумма превышает оплаченную"
                                : errors.customAmount || " "
                        }
                    />
                )}
            </div>
            {errors.condition && (
                <Typography color="error">{errors.condition}</Typography>
            )}
            <div>
                <h3 style={{ color: isAmountExceeded() ? "red" : "inherit" }}>
                    Вернется {formatMoney(sumBack)}
                </h3>
                {isAmountExceeded() && (
                    <Typography color="error" variant="body2">
                        Сумма превышает доступную для возврата (
                        {formatMoney(availableAmount)})
                    </Typography>
                )}
            </div>
            {showConfirmCheckbox && uploadedFiles.length === 0 && (
                <div className={stylePaymentBack.form_group}>
                    <Box display="flex" alignItems="center" component="label">
                        <Checkbox
                            name="confirmWithoutDocs"
                            color="primary"
                            checked={confirmWithoutDocs}
                            onChange={(e) => {
                                setConfirmWithoutDocs(e.target.checked);
                                if (errors.confirmWithoutDocs) {
                                    setErrors((prev) => {
                                        const newErrors = { ...prev };
                                        delete newErrors.confirmWithoutDocs;
                                        return newErrors;
                                    });
                                }
                            }}
                        />
                        <Typography>
                            Я согласен, что заявка на возврат оформляется без
                            прикрепления подтверждающих документов
                        </Typography>
                    </Box>
                    {errors.confirmWithoutDocs && (
                        <Typography color="error">
                            {errors.confirmWithoutDocs}
                        </Typography>
                    )}
                </div>
            )}
            <div className={stylePaymentBack.form_group}>
                <FileUploader onFilesChange={handleFilesChange} />
                {errors.files && (
                    <Typography color="error">{errors.files}</Typography>
                )}
            </div>
            <div style={{ display: "flex", gap: "10px", marginTop: "20px" }}>
                <Button
                    variant="outlined"
                    onClick={() => props.setOpenPaymentBackDialog(false)}
                    color="primary"
                    disabled={submitting}
                >
                    Закрыть
                </Button>
                <Button variant="contained" color="primary" type="submit">
                    {submitting ? (
                        <CircularProgress size={24} color="inherit" />
                    ) : (
                        "Сохранить"
                    )}
                </Button>
            </div>
        </form>
    );
};

const PaymentBackDialog = (props) => {
    const radioOptions = logicOfPolicyChoice(
        props?.cancelPolicy,
        props.dateIn,
        props.dateOut,
        props.sumTotal,
        props.paidAmount,
        props.priceFirstDay,
    );

    if (!props?.cancelPolicy || !props?.cancelPolicy?.length) {
        return <PopupData {...props} loading={true} />;
    }

    return <PopupData {...props} radioOptions={radioOptions} />;
};

PaymentBackDialog.propTypes = {
    openPaymentBackDialog: PropTypes.bool.isRequired,
    setOpenPaymentBackDialog: PropTypes.func.isRequired,
    cancelPolicy: PropTypes.array,
    dateIn: PropTypes.string,
    dateOut: PropTypes.string,
    reservationId: PropTypes.number,
    guestId: PropTypes.number,
    sumTotal: PropTypes.number,
    paidAmount: PropTypes.number,
    refundedAmount: PropTypes.number,
    hotelId: PropTypes.number,
    paymentNumber: PropTypes.string,
    orderNumber: PropTypes.string,
    setActiveHasRefunds: PropTypes.func.isRequired,
    setHasRefunds: PropTypes.func.isRequired,
    priceFirstDay: PropTypes.number,
    paymentMade: PropTypes.bool,
};

export default PaymentBackDialog;
